import { Box, Typography } from "@mui/material";
import ImageWithLoader from "./ImageWithLoader";

const getInitials = (name) => {
  if (!name) return "??";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "??";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

/**
 * Renders a real photo when `src` is provided, otherwise a locally
 * rendered colored circle with initials — no network dependency
 * (replaces the old ui-avatars.com fallback used throughout the app).
 * Mirrors ngwaahia-mobile/components/ui/Avatar.js.
 */
const Avatar = ({ src, name, size = 40, sx, imgStyle, alt }) => {
  if (src) {
    return (
      <ImageWithLoader
        src={src}
        alt={alt || name || ""}
        sx={{
          width: size,
          height: size,
          borderRadius: "50%",
          flexShrink: 0,
          ...sx,
        }}
        imgStyle={imgStyle}
      />
    );
  }

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "50%",
        bgcolor: "#046287",
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: Math.round(size * 0.4),
          lineHeight: 1,
        }}
      >
        {getInitials(name)}
      </Typography>
    </Box>
  );
};

export default Avatar;
